export const colorSecondary: React.CSSProperties = {
  color: '#a0a0a0'
};

export const fullWidth: React.CSSProperties = {
  width: '100%'
};

export const list: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  marginBottom: '130px',
  paddingRight: '32px',
};

export const commitTitle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  width: '100%',
};

export const commitMessage: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  gap: '12px',
};

export const commitDescription: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  width: '100%',
};

export const linkRepositoryContainer: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  gap: '32px',
};
